export const lightType = [
  {
    value: "WHITE_LIGHT",
    label: "白光",
    lightEffect: undefined,
    child: [
      {
        value: "COLOR_TEMPERATURE",
        label: "色温",
        child: [
          { value: "brightness", label: "亮度", num: "", condition: true },
          { value: "colorTemperature", label: "色温", num: "", condition: true },
          { value: "gm", label: "gm", num: "", condition: true },
          {
            value: "ctb",
            label: "ctb",
            num: "",
            condition: (lightEffect) => lightEffect === "COLOR_TEMPERATURE_PIECE"
          },  //
          { value: "cto", label: "cto", num: "", condition: (lightEffect) => lightEffect === "COLOR_TEMPERATURE_PIECE" }  // COLOR_TEMPERATURE_PIECE
        ]
      },
      { value: "LIGHT_SOURCE_LIBRARY", label: "光源库" },
      { value: "LIGHT_SOURCE_MATCH", label: "光源匹配" }
    ]
  },
  {
    value: "COLORAMA",
    label: "彩光",
    child: [
      { value: "COLOURED_PAPER", label: "色纸" },
      { value: "HSI", label: "HSI" },
      { value: "RGB", label: "RGB" },
      { value: "COLOR_COORDINATE", label: "色坐标" },
      { value: "COLOR_PICKER", label: "拾色器" }
    ]
  },
  {
    value: "LIGHT_EFFECT",
    label: "光效",
    child: [
      { value: "SYSTEM", label: "系统" },
      { value: "MANUAL", label: "专业手动" },
      { value: "COLOR_EFFECT_PICKER", label: "光效拾取" }
    ]
  }
];
let LightTypeMap = {};
// const LightTypeMap = {
//   "COLOR_TEMPERATURE":  {
//     value: "COLOR_TEMPERATURE",
//     label: "色温",
//     param: [
//       { value: "brightness", label: "亮度", num: "", condition: true },
//       { value: "colorTemperature", label: "色温", num: "", condition: true },
//       { value: "gm", label: "gm", num: "", condition: true },
//       { value: "ctb", label: "ctb", num: "", condition: true },  // COLOR_TEMPERATURE_PIECE
//       { value: "cto", label: "cto", num: "", condition: true }  // COLOR_TEMPERATURE_PIECE
//     ]
//   }
// };
// 把 数组 改成 {}
// function Obj(data = []) {
//   if (!data || !data.length) return {};
//   return data.reduce((acc, cur) => {
//     const { value } = cur;
//     acc[value] = cur?.child;
//     return acc;
//   }, {});
// }
//
// function getLightTypeMaps() {
//   return lightType.reduce((acc, cur) => {
//     const { value, child = [] } = cur;
//     acc[value] = Obj(child);
//     return acc;
//   }, LightTypeMap);
// }
//
// if (!(Object.keys(LightTypeMap).length)) {
//   getLightTypeMaps();
// }
// function verifyType(obj) {
//   return Object.prototype.toString.call(obj);
// }
// export const lightTypeFilterText = (obj, lightType, lightEffect) => {
//
//   /**
//    *  根据 lightType 获取对应的 子参数
//    *  lightEffect 是子参数是否显示的的条件
//    * */
//   const lightTypeParam = LightTypeMap[lightType];
//   // lightTypeParam.
//   Object.keys(lightTypeParam).forEach(el => {
//     let item = lightTypeParam[el];
//     if (!item || !item.length) return false;
//     item = item.map(elm => {
//       const {value, condition} = elm;
//       elm[value] = obj[value];
//       if (verifyType(condition) === '[object Function]') {
//         elm.condition = condition.bind(null, lightEffect)
//       }
//
//       return elm;
//     })
//   })
//   console.log(lightTypeParam, "lightTypeParam");
//
//   // if (!lightTypeParam) return '';
//   //
//   // lightTypeParam.forEach(el => {
//   //   const {value} = el;
//   //   el.num = obj?.[value] || ''
//   // })
//   //
//   // console.log(lightTypeParam, "lightTypeParam");
// };
// lightTypeFilterText();
export const lightEffect = [
  // 白光
  { value: "COLOR_TEMPERATURE", label: "色温", param: {} },
  { value: "LIGHT_SOURCE_LIBRARY", label: "光源库", param: {} },
  { value: "LIGHT_SOURCE_MATCH", label: "光源匹配", param: {} },
  // 彩光
  { value: "COLOURED_PAPER", label: "色纸", param: {} },
  { value: "HSI", label: "HSI", param: {} },
  { value: "RGB", label: "RGB", param: {} },
  { value: "COLOR_COORDINATE", label: "色坐标", param: {} },
  { value: "COLOR_PICKER", label: "拾色器", param: {} },
  // 光效
  { value: "SYSTEM", label: "系统", param: {} },
  { value: "MANUAL", label: "专业手动", param: {} },
  { value: "COLOR_EFFECT_PICKER", label: "光效拾取", param: {} }
];
export const checkStatusMaps = {
  "WAIT_CHECK": "待审核",
  "PASS": "已通过",
  "REJECT": "已拒绝",
  "REVOKE": "已撤销"
};
export const checkStatusSelect = [
  { value: undefined, label: "全部" },
  { value: "WAIT_CHECK", label: "待审核" },
  { value: "PASS", label: "已通过" },
  { value: "REJECT", label: "已拒绝" },
  { value: "REVOKE", label: "已撤销" }
];
export const deviceType = {
  enumerate: {
    "WHITE_LIGHT": "白光",
    "RGB": "RGB",
    "TWO_COLOR_TEMPERATURE": "双色温",
    "OTHER": "其他"
  },
  select: [
    { value: "WHITE_LIGHT", label: "白光" },
    { value: "RGB", label: "RGB" },
    { value: "TWO_COLOR_TEMPERATURE", label: "双色温" },
    { value: "OTHER", label: "其他" }
  ]
};
export const updateType = [{ value: "OTA", label: "OTA" },{ value: "DFU", label: "DFU" }]; // 更新类型，枚举类型 OTA、BFU
export const lang = {
  "options": [{value: "cn", label: "中文"},{value: "nl", label: "荷兰"},{value: "fr", label: "法语"},{value: "en", label: "英语"},{value: "es", label: "西语"},{value: "it", label: "意大利语"},{value: "ja", label: "日语"},{value: "de", label: "德语"}],
  "default": "cn" 
};
